import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

const HeroCarousel = ({ slides }) => {
  if (!slides || slides.length === 0) {
    return (
      <section className="h-[500px] relative" style={{ backgroundColor: '#9E1B32' }}>
        <div className="h-full flex items-center justify-center">
          <div className="text-center max-w-4xl px-4">
            <div className="h-12 w-96 mx-auto rounded bg-white/10 animate-pulse mb-5" />
            <div className="h-6 w-64 mx-auto rounded bg-white/10 animate-pulse" />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section data-testid="hero-carousel">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation
        loop
        className="hero-swiper"
        style={{ height: '500px' }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id || index} style={{ height: '500px' }}>
            <div
              className="relative w-full bg-cover bg-center"
              style={{ 
                backgroundImage: `url(${slide.background_image})`,
                height: '500px'
              }}
              data-testid={`hero-slide-${index}`}
            >
              {/* Red/maroon overlay */}
              <div 
                className="absolute inset-0"
                style={{ backgroundColor: 'rgba(100, 20, 30, 0.55)' }}
              />
              
              {/* Content - Centered */}
              <div className="relative z-10 h-full flex items-center justify-center">
                <div className="text-center max-w-4xl px-4">
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                  >
                    <h1 
                      className="text-3xl sm:text-4xl lg:text-5xl font-light text-white leading-tight mb-5"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                      data-testid={`hero-headline-${index}`}
                    >
                      {slide.headline}
                    </h1>
                    <p 
                      className="text-base sm:text-lg text-white/90 mb-6 leading-relaxed max-w-2xl mx-auto"
                      data-testid={`hero-subheadline-${index}`}
                    >
                      {slide.subheadline}
                    </p>
                    <Link 
                      to={slide.cta_url}
                      className="hero-cta-button inline-block px-8 py-3 text-sm uppercase tracking-wider font-semibold rounded-sm transition-all duration-300"
                      data-testid={`hero-cta-${index}`}
                    >
                      {slide.cta_text}
                    </Link>
                  </motion.div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default HeroCarousel;
